import { takeLatest, all } from "redux-saga/effects";
// Actions
import {
  LOGIN_SAGA,
  RECOVER_PASWORD_SAGA,
  LOGOUT_SAGA,
  REFRESH_TOKEN_SAGA,
} from "../Login/Action";
// Saga
import {
  loginSaga,
  recoverPasswordSaga,
  logoutSaga,
  refreshTokenSaga,
} from "./auth";

export default function* root() {
  yield all([
    /**
     * @see https://redux-saga.js.org/docs/basics/UsingSagaHelpers.html
     */
    // Call saga to log in the application
    takeLatest(LOGIN_SAGA, loginSaga),
    // Call saga to recover application password
    takeLatest(RECOVER_PASWORD_SAGA, recoverPasswordSaga),
    // Call saga to log out of the application
    takeLatest(LOGOUT_SAGA, logoutSaga),
    // Call saga to refresh application token
    takeLatest(REFRESH_TOKEN_SAGA, refreshTokenSaga),
  ]);
}



// WEBPACK FOOTER //
// ./src/stores/sagas/index.js